import React, {useState, useRef, useEffect} from 'react';
import { connect } from 'react-redux';
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
import { 
    Flex, Box, Text, VStack, Spacer, Divider, Link, Checkbox, Center, Button
} from '@chakra-ui/react';
import { FormattedDate, FormattedTime, FormattedNumber } from 'react-intl';
import { isNil, cloneDeep } from 'lodash';
import { withNamespaces } from 'react-i18next';

import { setNavTab } from '../../redux/actions';
import { getCurrentNavTab, getServicePriceList } from '../../redux/selectors';
import { ACTIVE_SERVICE_PRICE_TAB } from '../../redux/constants';
import { apiLoadListServicePrice } from '../../redux/apis/ServicePriceApis';
import { PATIENT_INFORMATION_MAX_AGE } from '../../constants'
import { displayConfirmAlert } from '../utils';

import Header from '../Home/Header';
import Navbar from '../Home/Navbar';
import NoDataPage from '../../components/NoData';
import NoEventPage from '../../components/NoEvent';

function ServicePrices(props) {
    const [ cookies, setCookie, removeCookie ] = useCookies(["selectedClinic", "loginCookie", "makeDoctorAppointmentDatas",]);
    const mounted = useRef();
    const navigate = useNavigate();
    const [ selectedServicePrices , setSelectedServicePrices ] = useState({});
    const t = props.t;

    useEffect(() => {
        if(!mounted.current) {
            if(isNil(cookies.selectedClinic?.data?.id)) {
                displayConfirmAlert("Bạn vui lòng chọn phòng khám trước khi tiếp tục!", () => {
                    navigate("/");
                });
            } else {
                props.apiLoadListServicePrice({ 
                    company_id: cookies?.selectedClinic?.data?.id, 
                    order_by: "name", 
                    order_dir: "asc", 
                    limit: 100000, 
                    offset: 0 
                });
                props.setNavTab(ACTIVE_SERVICE_PRICE_TAB);
            }

            if(cookies.makeDoctorAppointmentDatas?.data?.servicePriceDetail) {
                setSelectedServicePrices(cookies.makeDoctorAppointmentDatas?.data?.servicePriceDetail);
            }
            mounted.current = true;
        }
    });

    useEffect(() => {
        // console.log("---- props.servicePriceList", props.servicePriceList)
        // if(props.servicePriceList && props.servicePriceList?.length === 0) {
        //     navigate('/view_patient_ticket');
        // }

        if(cookies.makeDoctorAppointmentDatas?.data?.servicePriceDetail) {
            return;
        }

        let _currentSelectedServicePrices = {};
        
        props.servicePriceList && props.servicePriceList.map(item => {
            if(item.is_initial_fee) {
                _currentSelectedServicePrices[item.id] = {
                    name: item.name,
                    price: item.price,
                    checked: item.is_initial_fee
                }
            }
        });

        setSelectedServicePrices(_currentSelectedServicePrices);
    }, [props.servicePriceList]);

    const checkValidPreviousStep = () => {
        if(!cookies.makeDoctorAppointmentDatas?.data?.patientDetail) {
            displayConfirmAlert("Bạn chưa điền thông tin đăng ký khám!", () => navigate("/"));
            return;
        } else if(!cookies.makeDoctorAppointmentDatas?.data?.departmentDetail) {
            displayConfirmAlert("Bạn chưa chọn phòng khám!", () => navigate("/department"));
            return;
        } else if(!cookies.makeDoctorAppointmentDatas?.data?.doctorDetail) {
            displayConfirmAlert("Bạn chưa chọn bác sỹ khám!", () => navigate("/doctor"));
            return;
        }
    }

    const handleConfirm = () => {
        const _currentSelectedServicePrices = cloneDeep(selectedServicePrices);

        Object.keys(selectedServicePrices).map(key => {
            if(!selectedServicePrices[key]["checked"]) {
                delete _currentSelectedServicePrices[key];
            }
        })

        setCookie("makeDoctorAppointmentDatas", 
            { 
                data: {
                    ...cookies.makeDoctorAppointmentDatas?.data,
                    servicePriceDetail: _currentSelectedServicePrices,
                } 
            }, 
            { 
                path: '/', maxAge: PATIENT_INFORMATION_MAX_AGE
            }
        );

        navigate('/view_patient_ticket');
    }


    if(!(cookies.selectedClinic?.data?.id)) {
        return (
            <Flex flexDirection="column">
                <Header />
                <Navbar />
                <NoEventPage text="Bạn vui lòng chọn phòng khám trước khi tiếp tục!"/>
            </Flex>
        )
    }

    return (
        <React.Fragment>
            <Box>
                <Header />
                <Navbar />

                {
                    (props.servicePriceList.length > 0) &&
                    <Box py={8} textAlign="center">
                        <Text fontSize="32px" fontWeight="700" color="#007F4E" textTransform="uppercase">{t("Service_Price")}</Text>
                        <Flex flexDirection="row" flexWrap="wrap" justifyContent={{ base: "center", md: "center", lg: "center" }} px="2vw" py="1vh">
                            {
                                props.servicePriceList?.length > 0 && props.servicePriceList.map(item => {
                                    return (
                                        <VStack key={item.id} borderRadius={8} borderColor={ selectedServicePrices[item.id]?.["checked"] ? "green.500" : "black.700" } 
                                            borderWidth="2px" width="250px" height="100%"
                                            boxShadow="lg" mt={4} mx={2} p={4} justify="flex-start"
                                        >
                                            <Checkbox colorScheme='orange' value={item.id} isChecked={selectedServicePrices[item.id]?.["checked"]}
                                                isReadOnly={item.is_initial_fee}
                                                onChange={(evt) => {
                                                        // check is filled data, department, doctor
                                                        checkValidPreviousStep();

                                                        let _currentSelectedServicePrices = cloneDeep(selectedServicePrices);
                                                        _currentSelectedServicePrices[parseFloat(evt.currentTarget.value)] = {
                                                            name: item.name,
                                                            price: item.price,
                                                            checked: evt.currentTarget.checked
                                                        };
                                                        setSelectedServicePrices(_currentSelectedServicePrices);
                                                    }
                                                }
                                            >
                                                <Text fontWeight="600">{`${item.name} ${item.is_initial_fee ? "(Phí ban đầu)" :""}`}</Text>
                                                <Text fontSize="16px" fontWeight="700" color="#007F4E">
                                                    { item.price && <FormattedNumber value={item.price}></FormattedNumber> } VND
                                                </Text>
                                            </Checkbox>
                                        </VStack>
                                    )
                                })
                            }
                        </Flex>
                        <Flex flexDirection="column" w="100%" mb={4} align="center">
                            {/* <Text as="i">Phí ban đầu là chi phí cố định bệnh nhân thanh toán khi đặt lịch khám</Text> */}
                            <Button colorScheme='green' type='submit' width="300px" height="70px" mt={2} 
                                isDisabled={!cookies.makeDoctorAppointmentDatas?.data?.patientDetail}
                                // isDisabled={!cookies.makeDoctorAppointmentDatas?.data?.patientDetail || Object.values(selectedServicePrices)?.length <= 0}
                                onClick={handleConfirm}
                            >
                                <Text fontSize="18px" fontWeight="700">{t("Confirm")}</Text>
                            </Button>
                        </Flex>
                    </Box>
                }

                {
                    (props.servicePriceList.length === 0) &&
                    <VStack width="100%" justify="flex-start" align="center" mt={20} px={4} spacing={2}>
                        <NoDataPage text="Hiện tại chưa có dữ liệu về Dịch vụ."/>
                        {
                            (cookies?.loginCookie && cookies?.loginCookie?.data?.company_id === cookies?.selectedClinic?.data?.id) &&
                            <Text fontSize={{ base: "16px", md: "18px", lg: "18px" }} fontWeight="700">
                                Bạn có thể tạo dữ liệu dịch vụ từ 
                                <Link color="teal.500" href='/settings' fontWeight="700" target="_blank" ml={1}>Danh mục dịch vụ</Link>
                            </Text>
                        }
                    </VStack>
                }
            </Box>
        </React.Fragment>
    )
}

const mapStateToProps = (state) => {
    const servicePriceList      =   getServicePriceList(state);
    const currentNavTab         =   getCurrentNavTab(state);

    return { servicePriceList, currentNavTab };
}

const mapDispatchToProps = (dispatch) => ({
    apiLoadListServicePrice:        payload => dispatch(apiLoadListServicePrice(payload)),

    setNavTab:                      payload => dispatch(setNavTab(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(ServicePrices));